import { render } from "./VideoListShell.vue?vue&type=template&id=520b0c64&scoped=true"
import script from "./VideoListShell.vue?vue&type=script&lang=js"
export * from "./VideoListShell.vue?vue&type=script&lang=js"

import "./VideoListShell.vue?vue&type=style&index=0&id=520b0c64&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520b0c64"]])

export default __exports__